import type { ComponentProps } from "@blocknote/react";

type Props = ComponentProps["Generic"]["Form"]["Root"];
export function Root({ children }: Props) {
  return <>{children}</>;
}
